export default __webpack_public_path__ + "static/media/flex-direction-axis.fc4f468b.jpg";